import "./TemplatePage.css";

import React, { useEffect, useState } from "react";

import axios from "axios";

import { useParams } from "react-router-dom";

import { END_URL } from "../../config";

import gg from "../../images/pp-logo.gif";

function TemplatePage() {

    const { slug } = useParams();

    const reservedSlugs = [

        "asmandnacho",

        "64Archetypes",

        "top-tier-subscriptions",

        "blog",

        "contact",

    ];

    const isReserved = reservedSlugs.includes(slug);

    const [page, setPage] = useState(null);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState("");

    useEffect(() => {

        const container = document.querySelector('.priv-main');

        if (!container) return;

        const handleClick = (e) => {

            if (
                e.target.tagName === 'INPUT' &&
                e.target.type === 'button'
            ) {
                const url = e.target.name;

                if (url) {
                    window.open(url, '_blank');
                }
            }
        };

        container.addEventListener('click', handleClick);

        return () => {
            container.removeEventListener('click', handleClick);
        };

    }, [page]);

    const cleanHeadingBoldTags = (html) => {

        if (!html) return "";

        const temp = document.createElement("div");

        temp.innerHTML = html;

        const headings = temp.querySelectorAll(
            "h1, h2, h3, h4, h5, h6"
        );

        headings.forEach((heading) => {

            heading.innerHTML = heading.innerHTML
                .replace(/<\/?b>/gi, "")
                .replace(/<\/?strong>/gi, "");

        });

        return temp.innerHTML;
    };

    useEffect(() => {

        if (isReserved) return;

        fetchPage();

    }, [slug]);

    const fetchPage = async () => {

        try {

            setLoading(true);

            const response = await axios.get( `${END_URL}/template/${slug}`);
               
            if (response.data.success) {

                const pageData = response.data.data;

                if (pageData?.contents) {

                    pageData.contents = pageData.contents.map(item => ({
                        ...item,
                        content: cleanHeadingBoldTags(item.content)

                    }));
                }

                setPage(pageData);

            } else {

                setError("Page not found");
            }

        } catch (error) {

            console.log(error);

            setError("Failed to load page");

        } finally {

            setLoading(false);
        }
    };

    if (loading) {

        return (
               <div className="loadingDiv" >
                
                    <img src={gg}  alt="Loading..." />
        
                </div>
        );
    }

    if (error) {

        return (
            <div className="container py-5 text-danger">
                {error}
            </div>
        );
    }

    return (
        <div className="priv-main">

            <div className="container">

                <div className="row">

                    <div className="col-md-12 priv-text-div">

                        <div className="priv-title">

                            <h1>
                                {page?.display_name}
                            </h1>

                        </div>

                        {page?.contents?.map((item) => (

                            <div
                                key={item.id}
                                className="priv-text"
                                dangerouslySetInnerHTML={{
                                    __html: item.content
                                }}
                            />

                        ))}

                    </div>

                </div>

            </div>

        </div>
    );
}

export default TemplatePage;